import { IconProps } from "../../utils/global-types/global-types";

const CheckIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_1273_91411)">
        <path
          fill="currentColor"
          d="M14.714 4.954a.95.95 0 0 0-1.346 0L7.31 11.012 4.617 8.319a.952.952 0 1 0-1.346 1.347l3.366 3.365a.95.95 0 0 0 1.346 0l6.73-6.731a.95.95 0 0 0 0-1.346"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1273_91411">
          <path fill="#fff" d="M2.992 2.992h12v12h-12z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckIcon;
